// utils/presetFields.js
import { __ } from '@wordpress/i18n';

export const presetFields = {
  basic: {
    name: __('Basic Fields', 'havenlytics'),
    icon: 'user',
    fields: [
      {
        id: 'preset_hvnly_property_field_fullname',
        type: 'text',
        icon: 'user',
        defaultLabel: __('Full Name', 'havenlytics'),
        defaultPlaceholder: __('Enter your full name', 'havenlytics'),
        defaultRequired: true,
        defaultAdminOnly: false,
        category: 'basic'
      },
      {
        id: 'preset_hvnly_property_field_email',
        type: 'text',
        icon: 'envelope',
        defaultLabel: __('Email Address', 'havenlytics'),
        defaultPlaceholder: __('your.email@example.com', 'havenlytics'),
        defaultRequired: true,
        defaultAdminOnly: false,
        category: 'basic'
      },
      {
        id: 'preset_hvnly_property_field_phone',
        type: 'text',
        icon: 'phone',
        defaultLabel: __('Phone Number', 'havenlytics'),
        defaultPlaceholder: __('(123) 456-7890', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'basic'
      },
      {
        id: 'preset_hvnly_property_field_company',
        type: 'text',
        icon: 'building',
        defaultLabel: __('Company Name', 'havenlytics'),
        defaultPlaceholder: __('Enter company name', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'basic'
      
      },
      {
        id: 'preset_hvnly_property_field_website',
        type: 'text',
        icon: 'globe',
        defaultLabel: __('Website', 'havenlytics'),
        defaultPlaceholder: __('Enter website URL', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'basic'
      }
    ]
  },
  property: {
    name: __('Property Details', 'havenlytics'),
    icon: 'home',
    fields: [
      {
        id: 'preset_hvnly_property_field_number_bedrooms',
        type: 'number',
        icon: 'bed',
        defaultLabel: __('Bedrooms', 'havenlytics'),
        defaultPlaceholder: __('Number of bedrooms', 'havenlytics'),
        defaultRequired: true,
        defaultAdminOnly: false,
        category: 'property'
      },
      {
        id: 'preset_hvnly_property_field_number_bathrooms',
        type: 'number',
        icon: 'bath',
        defaultLabel: __('Bathrooms', 'havenlytics'),
        defaultPlaceholder: __('Number of bathrooms', 'havenlytics'),
        defaultRequired: true,
        defaultAdminOnly: false,
        category: 'property'
      },
      {
        id: 'preset_hvnly_property_field_number_squarefeet',
        type: 'number',
        icon: 'ruler-combined',
        defaultLabel: __('Square Feet', 'havenlytics'),
        defaultPlaceholder: __('Total square footage', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'property'
      },
      {
        id: 'preset_hvnly_property_field_number_garage',
        type: 'number',
        icon: 'car',
        defaultLabel: __('Garage Spaces', 'havenlytics'),
        defaultPlaceholder: __('Number of garage spaces', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'property'
      }
    ]
  },
  location: {
    name: __('Location', 'havenlytics'),
    icon: 'map-marker-alt',
    fields: [
      // {
      //   id: 'preset_hvnly_property_field_text_address',
      //   type: 'text',
      //   icon: 'map-marker-alt',
      //   defaultLabel: __('Street Address', 'havenlytics'),
      //   defaultPlaceholder: __('123 Main Street', 'havenlytics'),
      //   defaultRequired: true,
      //   defaultAdminOnly: false,
      //   category: 'location'
      // },
      {
        id: 'preset_hvnly_property_field_text_city',
        type: 'text',
        icon: 'city',
        defaultLabel: __('City', 'havenlytics'),
        defaultPlaceholder: __('City name', 'havenlytics'),
        defaultRequired: true,
        defaultAdminOnly: false,
        category: 'location'
      },
      // {
      //   id: 'preset_hvnly_property_field_select_state',
      //   type: 'select',
      //   icon: 'flag-usa',
      //   defaultLabel: __('State/Province', 'havenlytics'),
      //   defaultPlaceholder: __('Select state/province', 'havenlytics'),
      //   defaultRequired: true,
      //   defaultAdminOnly: false,
      //   category: 'location'
      // },
      {
        id: 'preset_hvnly_property_field_text_zipcode',
        type: 'text',
        icon: 'map-pin',
        defaultLabel: __('ZIP/Postal Code', 'havenlytics'),
        defaultPlaceholder: __('12345', 'havenlytics'),
        defaultRequired: true,
        defaultAdminOnly: false,
        category: 'location'
      }
    ]
  },
  amenities: {
    name: __('Amenities', 'havenlytics'),
    icon: 'star',
    fields: [
      {
        id: 'preset_hvnly_property_field_checkbox_pool',
        type: 'checkbox',
        icon: 'swimming-pool',
        defaultLabel: __('Swimming Pool', 'havenlytics'),
        defaultPlaceholder: __('Has swimming pool', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'amenities'
      },
      {
        id: 'preset_hvnly_property_field_checkbox_garden',
        type: 'checkbox',
        icon: 'tree',
        defaultLabel: __('Garden', 'havenlytics'),
        defaultPlaceholder: __('Has garden', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'amenities'
      },
      {
        id: 'preset_hvnly_property_field_checkbox_garage',
        type: 'checkbox',
        icon: 'warehouse',
        defaultLabel: __('Garage', 'havenlytics'),
        defaultPlaceholder: __('Has garage', 'havenlytics'),
        defaultRequired: false,
        defaultAdminOnly: false,
        category: 'amenities'
      }
    ]
  }
};